import React from 'react'

export default ({value}) => {
    return <div className="setting-component__action--column-group">
        {value}
    </div>
}